import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import { Link, useParams } from 'react-router-dom';
import printJS from 'print-js';

const semesterMapping = {
  "Semester First": ["Unit Test I", "Unit Test II", "Semester First "],
  "Semester Second": ["Unit Test III", "Unit Test IV", "Semester Second "]
};

const updateExamList = (selectedExamName, setExams) => {
  setExams(semesterMapping[selectedExamName] || []);
};
 
// Function to get the semester value from the URL
const getSemesterFromURL = () => { 
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('semester');
};

// Function to handle URL changes and update the modal
const handleURLChange = (setExams) => {
  const semester = getSemesterFromURL();
  if (semester) {
    updateExamList(semester, setExams);
  }
};

const ResultModal = ({ isOpen, onClose, selectedStudentResults, subjectSequence, calculateGrade, language }) => {
  const { selectedExamName } = useParams(); // Use useParams to get the URL parameter
  const [exams, setExams] = useState([]);

  useEffect(() => {
    setExams(semesterMapping[selectedExamName] || []);
  }, [selectedExamName]);

  useEffect(() => {
    handleURLChange(setExams);
  }, []);

  if (!isOpen) return null;

  return (
    <Modal show={isOpen} onHide={onClose} dialogClassName='modal-80w'>
      <Modal.Header closeButton>
        <Modal.Title>{selectedExamName} Exams</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedStudentResults ? (
          <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
            <thead>
              <tr>
                <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                {exams.map((exam, index) => (
                  <th key={index} colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? exam : exam}</th>
                ))}
                <th colSpan="3" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grand Total" : "एकूण गुण"}</th>
                <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
              </tr>
              <tr>
                {exams.map((exam, index) => (
                  <>
                    <th key={`${exam}-mm`} style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                    <th key={`${exam}-obt`} style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                  </>
                ))}
                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "P %" : "%"}</th>
              </tr>
            </thead>
            <tbody>
              {subjectSequence
                .filter((subject) => {
                  const grades = selectedStudentResults.results[subject];
                  return grades && (
                    exams.some(exam => grades[`${exam.replace(/\s+/g, '')}ObtainMarks`]) ||
                    grades.obtainMarks
                  );
                })
                .map((subject) => {
                  const grades = selectedStudentResults.results[subject];
                  const totalOutOf = exams.reduce((total, exam) => total + (grades[`${exam.replace(/\s+/g, '')}OutOf`] || 0), 0) + (grades.outOf || 0);
                  const totalObtainMarks = exams.reduce((total, exam) => total + (grades[`${exam.replace(/\s+/g, '')}ObtainMarks`] || 0), 0) + (grades.obtainMarks || 0);
                  const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                  const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                  return (
                    <tr key={subject} style={{ padding: "2px" }}>
                      <td style={{ padding: "2px", color: 'black' }}>{subject}</td>
                      {exams.map((exam, index) => (
                        <>
                          <td key={`${exam}-outof-${index}`} style={{ padding: "2px", color: 'black' }}>{grades[`${exam.replace(/\s+/g, '')}OutOf`] || "-"}</td>
                          <td key={`${exam}-obtain-${index}`} style={{ padding: "2px", color: 'black' }}>{grades[`${exam.replace(/\s+/g, '')}ObtainMarks`] || "-"}</td>
                        </>
                      ))}
                      <td style={{ padding: "2px", color: 'black' }}><b>{totalOutOf}</b></td>
                      <td style={{ padding: "2px" }}><b>{totalObtainMarks}</b></td>
                      <td style={{ padding: "2px" }}><b>{rowPercentage}</b></td>
                      <td style={{ padding: "2px" }}><b>{grade}</b></td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

function WebIcseResult() {
  const {udiseNumber, srNo, academicYear, classValue, division, selectedExamName} = useParams();
  const [students, setStudents] = useState([]);
  const [exams, setExams] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({});
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [subjectSequence, setSubjectSequence] = useState([]);
  const [selectedStudentForSr, setSelectedStudentForSr] = useState('');

  useEffect(() => {
    fetchStudents();
    updateExamList(selectedExamName, setExams);
  }, [division, selectedExamName]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (academicYear && classValue && division) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue, division]);

  useEffect(() => {
    fetchSchoolName();
    fetchStudentData();
  }, [udiseNumber, srNo, academicYear, classValue, selectedExamName, division]);

  useEffect(() => {
    if (selectedExamName && classValue && academicYear && division) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear, division]);

  const fetchStudents = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch students');
      }
      const data = await response.json();
      if (data === null) {
        console.warn('Received null response for students data');
        return [];
      }
      // Process the data if it's not null
      const students = Object.values(data);
      return students;
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  };

  const fetchSubjectSequence = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch subject sequence');
      }
      const data = await response.json();
      const orderedSubjects = Object.keys(data)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((key) => data[key]);
      setSubjectSequence(orderedSubjects);
    } catch (error) {
      console.error('Error fetching subject sequence:', error);
    }
  };

  const fetchSchoolName = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch school name');
      }
      const data = await response.json();
      setSchoolName(data.schoolName || '-');
      setSchoolLogo(data.schoolLogo || '');
    } catch (error) {
      console.error('Error fetching school name:', error);
    }
  };

  const fetchMarksData = async (srNo, academicYear, examName) => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/icseResult/${academicYear}/${examName}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      const data = await response.json();
      console.log(`Fetched marks for ${examName}:`, data); // Log fetched marks data
      return data || {};
    } catch (error) {
      console.error('Error fetching marks data:', error);
      return {};
    }
  };

  const fetchStudentData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch student info');
      }
      const studentInfo = await response.json();

      // Check if the student's division matches the URL division
      if (studentInfo.division !== division) {
        setSelectedStudentResults(null);
        setShowModal(true);
        return;
      }

      const [
        unitTestIResponse,
        unitTestIIResponse,
        unitTestIIIResponse,
        unitTestIVResponse,
        firstSemesterResponse,
        secondSemesterResponse
      ] = await Promise.all([
        fetchMarksData(srNo, academicYear, 'Unit Test I'),
        fetchMarksData(srNo, academicYear, 'Unit Test II'),
        fetchMarksData(srNo, academicYear, 'Unit Test III'),
        fetchMarksData(srNo, academicYear, 'Unit Test IV'),
        fetchMarksData(srNo, academicYear, 'Semester First '), 
        fetchMarksData(srNo, academicYear, 'Semester Second '), 
      ]);

      console.log('All fetched marks data:', {
        unitTestIResponse,
        unitTestIIResponse,
        unitTestIIIResponse,
        unitTestIVResponse,
        firstSemesterResponse,
        secondSemesterResponse
      }); // Log all fetched marks data

    const resultsWithTotal = {};
      const allSubjects = new Set([
        ...Object.keys(unitTestIResponse || {}),
        ...Object.keys(unitTestIIResponse || {}),
        ...Object.keys(unitTestIIIResponse || {}),
        ...Object.keys(unitTestIVResponse || {}),
        ...Object.keys(firstSemesterResponse || {}),
        ...Object.keys(secondSemesterResponse || {}),
      ]);

      allSubjects.forEach((subject) => {
        resultsWithTotal[subject] = {
          unitTestIOutOf: unitTestIResponse?.[subject]?.outOf || 0,
          unitTestIObtainMarks: unitTestIResponse?.[subject]?.obtainMarks || 0,
          unitTestIIOutOf: unitTestIIResponse?.[subject]?.outOf || 0,
          unitTestIIObtainMarks: unitTestIIResponse?.[subject]?.obtainMarks || 0,
          unitTestIIIOutOf: unitTestIIIResponse?.[subject]?.outOf || 0,
          unitTestIIIObtainMarks: unitTestIIIResponse?.[subject]?.obtainMarks || 0,
          unitTestIVOutOf: unitTestIVResponse?.[subject]?.outOf || 0,
          unitTestIVObtainMarks: unitTestIVResponse?.[subject]?.obtainMarks || 0,
          firstSemesterOutOf: firstSemesterResponse?.[subject]?.outOf || 0,
          firstSemesterObtainMarks: firstSemesterResponse?.[subject]?.obtainMarks || 0,
          secondSemesterOutOf: secondSemesterResponse?.[subject]?.outOf || 0,
          secondSemesterObtainMarks: secondSemesterResponse?.[subject]?.obtainMarks || 0,
          outOf: firstSemesterResponse?.[subject]?.outOf || 0,
          obtainMarks: firstSemesterResponse?.[subject]?.obtainMarks || 0,
          outOf: secondSemesterResponse?.[subject]?.outOf || 0,
          obtainMarks: secondSemesterResponse?.[subject]?.obtainMarks || 0,
        };
      });

      setSelectedStudentResults({
        studentName: studentInfo.stdName,
        stdMother: studentInfo.stdMother,
        stdFather: studentInfo.stdFather,
        stdSurname: studentInfo.stdSurname,
        dob: studentInfo.dob,
        division: studentInfo.division,
        motherTounge: studentInfo.motherTounge,
        studentId: studentInfo.studentId,
        gender: studentInfo.gender,
        rollNo: studentInfo.rollNo,
        results: resultsWithTotal,
        stdPhoto: studentInfo.stdPhoto
      });

      setShowModal(true);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };

  const fetchMarksForSelectedSubject = async () => {
    try {
      const selectedStudents = studentData.filter(
        (student) => student.currentClass === classValue && student.division === division
      );
      setSelectedStudents(selectedStudents);
      const marksDataPromises = selectedStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });

      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});

      setMarksData(marksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };

  const viewResult = async (srNo) => {
    try {
      const student = selectedStudents.find((student) => student.srNo === srNo);
      setSelectedStudentForSr(student);

      if (!student) {
        setAlertMessage("Student not found.");
        setSelectedStudentResults(null);
        setShowModal(true);
        return;
      }

      await fetchStudentData();
    } catch (error) {
      console.error("Error fetching student results:", error);
      setAlertMessage("Add the subject and fill the marks to view the icseResult.");
    }
  };

  const calculateGradeEnglish = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Fail';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return 'अ-1';
    if (total >= 80) return 'अ-2';
    if (total >= 70) return 'ब-1';
    if (total >= 60) return 'ब-2';
    if (total >= 50) return 'क-1';
    if (total >= 40) return 'क-2';
    if (total >= 30) return 'ड-1';
    if (total >= 20) return 'ड-2';
    return 'नापास';
  };

  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };

  const handleCloseModal = () => setShowModal(false);

  

  return (
    <div>
      <div className='main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)', textAlign: 'center' }}>
          {language === "English" ? "ICSE Exam Result " : " ICSE परीक्षेचा निकाल"}
        </h3>
        {selectedStudents.length > 0 && (
          <div className="mt-4">
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">{language === "English" ? "Roll No " : "हजेरी क्र"}</th>
                  <th>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव"}</th>
                  <th>{language === "English" ? "icseResult " : "प्रगतीपत्रक"}</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents.filter((student) => student.division === division).sort((a, b) => a.rollNo - b.rollNo).map((student) => (
                  <tr key={student.srNo}>
                    <td>{student.rollNo}</td>
                    <td>{student.stdName}{student.stdSurname}</td>
                    <td><button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>{language === "English" ? "View icseResult" : "प्रगति पत्रक"}</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <ResultModal isOpen={showModal} onClose={handleCloseModal} selectedStudentResults={selectedStudentResults} subjectSequence={subjectSequence} calculateGrade={calculateGrade} language={language} />
        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
         
          <Modal.Body>
            {selectedExamName === 'Semester Second' && selectedStudentResults ? (

              <div>
                {/* Semester Second  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>

                    <div className="school-info">
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '80px', height: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      )}

                      <h2>{schoolName}</h2>
                    </div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `SECOND SEMESTER EXAMINATION- ${academicYear}` : `द्वितीय सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right', }}>
                        <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                        <span>{classValue || '-'} {selectedStudentResults?.division || '-'} </span>
                      </div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test III" : "तिसरी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test IV" : "चौथी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester II" : "द्वितीय सत्र"}</th>
                            <th colSpan="3" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grand Total" : "एकूण गुण"}</th>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                          </tr>
                          <tr>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "P %" : "%"}</th>
                          </tr>
                        </thead>












                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Remove subjects if all relevant marks are null/undefined
                                return grades && (
                                  grades.unitTestIIIObtainMarks ||
                                  grades.unitTestIVObtainMarks ||
                                  grades.obtainMarks
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults.results[subject];

                                // Calculate row-wise totals
                                const totalOutOf = (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                const totalObtainMarks = (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                                const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>{subject}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIOutOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIObtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVOutOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVObtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.outOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.obtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}><b>{totalOutOf}</b></td>
                                    <td style={{ padding: "2px" }}><b>{totalObtainMarks}</b></td>
                                    <td style={{ padding: "2px" }}><b>{rowPercentage}</b></td>
                                    <td style={{ padding: "2px" }}><b>{grade}</b></td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}




                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                                </td>
                                {["unitTestIIIOutOf", "unitTestIIIObtainMarks", "unitTestIVOutOf", "unitTestIVObtainMarks", "outOf", "obtainMarks"].map((key, index) => (
                                  <td key={index} colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter(subject => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return total + (grades[key] || 0);
                                        }, 0)}
                                    </b>
                                  </td>
                                ))}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                                    })()}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Remarks" : "शेरा"}</b>
                                </td>
                                {/* Calculate and display the percentage for Unit Test III */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalUnitTestIIIOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0);
                                      }, 0);
                                      const totalUnitTestIIIObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0);
                                      }, 0);
                                      return totalUnitTestIIIOutOf > 0 ? ((totalUnitTestIIIObtained / totalUnitTestIIIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                {/* Calculate and display the percentage for Unit Test IV */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalUnitTestIVOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIVOutOf || 0);
                                      }, 0);
                                      const totalUnitTestIVObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIVObtainMarks || 0);
                                      }, 0);
                                      return totalUnitTestIVOutOf > 0 ? ((totalUnitTestIVObtained / totalUnitTestIVOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                {/* Calculate and display the percentage for Semester II */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalSemesterIIOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0);
                                      const totalSemesterIIObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalSemesterIIOutOf > 0 ? ((totalSemesterIIObtained / totalSemesterIIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                <td colSpan="4" style={{ padding: "5px" }}>
                                  {(() => {
                                    const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                    }, 0);
                                    const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                    }, 0);

                                    // Calculate percentage
                                    const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                    // Determine grade based on percentage
                                    const grade = language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);

                                    // Display remarks based on the grade
                                    if (grade === 'A+' || grade === 'अ-1') {
                                      return language === "English" ? "Excellent Performance" : "उत्कृष्ट कामगिरी";
                                    } else if (grade === 'A' || grade === 'अ-2') {
                                      return language === "English" ? "Very Good Performance" : "खूप चांगली कामगिरी";
                                    } else if (grade === 'B+' || grade === 'ब-1') {
                                      return language === "English" ? "Good Performance" : "चांगली कामगिरी";
                                    } else if (grade === 'B' || grade === 'ब-2') {
                                      return language === "English" ? "Satisfactory Performance" : "संतोषजनक कामगिरी";
                                    } else {
                                      return language === "English" ? "Needs Improvement" : "सुधारणा आवश्यक";
                                    }
                                  })()}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>

                      </table>
                    ) : (
                      <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}






                    <div style={{ marginTop: "10px", fontSize: "14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults.results[subject] || {};
                                return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults.results[subject] || {};
                                return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIObtainMarks || 0) +
                                (grades.unitTestIVObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>
                            {language === "English" ? "First Sem Percentage : " : "प्रथम सत्र टक्केवारी : "}
                            {(() => {
                              const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.firstSemesterOutOf || 0)
                                );
                              }, 0);
                              const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.firstSemesterObtainMarks || 0)
                                );
                              }, 0);
                              // Calculate percentage
                              return totalMaxMarks > 0
                                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                                : "0%";
                            })()}
                          </b>
                        </p>
                      </div>
                    </div>
                    <div>
                      <p>
                        <b>
                          {language === "English" ? "Percentage : " : "टक्केवारी : "}
                          {(() => {
                            const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIOutOf || 0) +
                                (grades.unitTestIVOutOf || 0) +
                                (grades.outOf || 0)
                              );
                            }, 0);
                            const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIObtainMarks || 0) +
                                (grades.unitTestIVObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0);
                            // Calculate percentage
                            return totalMaxMarks > 0
                              ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                              : "0%";
                          })()}
                        </b>
                      </p>
                    </div>
                    <div
                      className="grad"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's signature" : "पालकांची सही"}
                      </label>
                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
                      </label>
                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>














            ) : (
              <div>
                {/* Semester First  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>

                    <div className="school-info" >
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '80px', height: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      )}

                      <h2>{schoolName}</h2>
                    </div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `FIRST SEMESTER EXAMINATION- ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right', }}>
                        <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                        <span>{classValue || '-'} {selectedStudentResults?.division || '-'} </span>
                      </div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test I" : "पहिली चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test II" : "दुसरी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester I" : "प्रथम सत्र"}</th>
                            <th colSpan="3" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grand Total" : "एकूण गुण"}</th>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                          </tr>
                          <tr>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "P %" : "%"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Only include subjects where at least one of the grade fields has a valid value (not null or undefined)
                                return (
                                  grades && (
                                    grades.unitTestIObtainMarks ||
                                    grades.unitTestIIObtainMarks ||
                                    grades.obtainMarks)
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Calculate row-wise totals and percentage
                                const totalOutOf =
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.outOf || 0);
                                const totalObtainMarks =
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.obtainMarks || 0);
                                const rowPercentage =
                                  totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                                // Calculate grade based on the row percentage
                                const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      {subject}
                                    </td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIOutOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIObtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIOutOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIObtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.outOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.obtainMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      <b>{totalOutOf}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{totalObtainMarks}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{rowPercentage}</b>
                                    </td>
                                    {/* Display the grade */}
                                    <td style={{ padding: "2px" }}>
                                      <b>{grade}</b>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                                </td>
                                {["unitTestIOutOf", "unitTestIObtainMarks", "unitTestIIOutOf", "unitTestIIObtainMarks", "outOf", "obtainMarks"].map((key, index) => (
                                  <td key={index} colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter(subject => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return total + (grades[key] || 0);
                                        }, 0)}
                                    </b>
                                  </td>
                                ))}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.outOf || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                                    })()}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Remarks" : "शेरा"}</b>
                                </td>

                                {/* Calculate and display the percentage for Unit Test I */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalUnitTestIOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0);
                                      }, 0);
                                      const totalUnitTestIObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0);
                                      }, 0);
                                      return totalUnitTestIOutOf > 0 ? ((totalUnitTestIObtained / totalUnitTestIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>                                    {/* Calculate and display the percentage for Unit Test II */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalUnitTestIIOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIOutOf || 0);
                                      }, 0);
                                      const totalUnitTestIIObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIObtainMarks || 0);
                                      }, 0);
                                      return totalUnitTestIIOutOf > 0 ? ((totalUnitTestIIObtained / totalUnitTestIIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                {/* Calculate and display the percentage for Semester I */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      const totalSemesterIOutOf = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0);
                                      const totalSemesterIObtained = subjectSequence.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalSemesterIOutOf > 0 ? ((totalSemesterIObtained / totalSemesterIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                <td colSpan="4" style={{ padding: "5px" }}>
                                  {(() => {
                                    const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                    }, 0);
                                    const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                    }, 0);

                                    // Calculate percentage
                                    const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;

                                    // Determine grade based on percentage
                                    const grade = language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);

                                    // Display remarks based on the grade
                                    if (grade === 'A+' || grade === 'अ-1') {
                                      return language === "English" ? "Excellent Performance" : "उत्कृष्ट कामगिरी";
                                    } else if (grade === 'A' || grade === 'अ-2') {
                                      return language === "English" ? "Very Good Performance" : "खूप चांगली कामगिरी";
                                    } else if (grade === 'B+' || grade === 'ब-1') {
                                      return language === "English" ? "Good Performance" : "चांगली कामगिरी";
                                    } else if (grade === 'B' || grade === 'ब-2') {
                                      return language === "English" ? "Satisfactory Performance" : "संतोषजनक कामगिरी";
                                    } else {
                                      return language === "English" ? "Needs Improvement" : "सुधारणा आवश्यक";
                                    }
                                  })()}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}

                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>
                            {language === "English" ? "Percentage : " : "टक्केवारी : "}
                            {(() => {
                              const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.outOf || 0)
                                );
                              }, 0);

                              const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.obtainMarks || 0)
                                );
                              }, 0);

                              // Calculate percentage
                              return totalMaxMarks > 0
                                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                                : "0%";
                            })()}
                          </b>
                        </p>
                      </div>
                    </div>


                    <div
                      className="grad"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's signature" : "पालकांची सही"}
                      </label>

                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
                      </label>

                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>

                  </div>
                </div>

              </div>
            )}

          </Modal.Body>
          <Modal.Footer>
           
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  ); 
};


export default WebIcseResult;
